<template>
    <EndpageTemplate :model="model" :breadcrumb-items="breadcrumbItems" :recommended-articles="recommendedArticles" />
</template>

<script>
import EndpageTemplate from '@/components/Pages/Magazine/Template';

export default {
    name: 'Article',
    components: {
        EndpageTemplate,
    },
    layout: 'theme-dark',
    async asyncData({ $axios, params, redirect, localePath, i18n }) {
        let model = null;
        let recommendedArticles = [];

        await $axios
            .$get(`/news/by-slug/${params.article}`)
            .then((res) => {
                model = res;
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('magazine'));
        }

        await $axios
            .$get(`/news?category_id=${model.category_id}&limit=12`)
            .then((res) => {
                recommendedArticles = res.data.filter((x) => x.id !== model.id);
            })
            .catch((err) => {
                console.log(err);
            });

        await i18n.generateLocalizedRouteParams(model.locale_variants, 'article');

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('navigation.news'), 'magazine']);
        breadcrumbItems.push([model.title, 'article']);

        return {
            model,
            breadcrumbItems,
            recommendedArticles,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
};
</script>
